import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M8.304 12.947l5.748 4.993c.376.326.891.401 1.343.195s.734-.644.734-1.141V7.007a1.24 1.24 0 00-.734-1.141 1.245 1.245 0 00-1.343.195l-5.748 4.993a1.256 1.256 0 000 1.894z"
}), 'ArrowLeft');